class EmployeeUser {
    userId;
    endOfEmployment;
    employmentDate;
    firstName;
    lastName;
    employeeFullName;
    constructor(emp) {
        this.userId = emp.userId;
        this.firstName = emp.firstName;
        this.lastName = emp.lastName;
        this.employeeFullName = this.firstName + " " + this.lastName;
        if (emp.endOfEmployment !== null) {
            this.endOfEmployment = window.dateHandler.formatDateNoTime(emp.endOfEmployment);
        }
        else {
            this.endOfEmployment = emp.endOfEmployment;
        }
        this.employmentDate = window.dateHandler.formatDateNoTime(emp.employmentDate);
    }
}
export default EmployeeUser;
